import React from "react";

import cn from "classnames";

import { createComponentStyleHook } from "../../tokens";
import illustrationsNames from "./Illustration.Components";
import { IllustrationProps } from "./Illustration.props";

import legacyStyles from "./legacy/styles.module.scss";
import tokenStyles from "./styles.module.css";

const useStyles = createComponentStyleHook<IllustrationProps>({
  legacyStyles,
  tokenStyles,
  componentTokens: "brand_illustration",
});

const Illustration: React.FC<IllustrationProps> = (props: IllustrationProps): JSX.Element | null => {
  const { id, name, className, testId } = props;
  const { mode, styles, StyleModeBoundary } = useStyles(props);
  const illustrationClass = cn(styles["illustration"], className);

  if (typeof illustrationsNames[name] !== "undefined") {
    return (
      <StyleModeBoundary mode={mode}>
        {React.createElement(
          illustrationsNames[name],
          {
            id: id,
            className: illustrationClass,
            "data-testid": testId ? `test__${testId}-illustration` : undefined,
          },
          null,
        )}
      </StyleModeBoundary>
    );
  } else {
    return null;
  }
};

export default Illustration;
